import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const ImportOrManual = ({ onDownloadTemplate, onImportExcel, onManualAdd }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        {/* Import from Excel */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Import from Excel
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Download the Excel template and fill your data as per the
                format. Make sure column headers are not changed.
              </Typography>
              <Button
                variant="outlined"
                startIcon={<CloudDownloadIcon />}
                onClick={onDownloadTemplate}
              >
                Download Template
              </Button>
            </CardContent>
            <CardActions sx={{ px: 2, pb: 2 }}>
              <Button
                variant="contained"
                startIcon={<UploadFileIcon />}
                fullWidth
                onClick={onImportExcel}
                color="primary"
              >
                Upload Excel
              </Button>
            </CardActions>
          </Card>
        </Grid>

        {/* Add Manually */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Add Manually
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Add data manually by filling in the form step-by-step.
              </Typography>
            </CardContent>
            <CardActions sx={{ px: 2, pb: 2 }}>
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                fullWidth
                onClick={onManualAdd}
              >
                Add Manually
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ImportOrManual;
